/*
 * O que esta implantação é: 'Platform' (o portal que gere as instâncias), 'Gym' (um ginásio) ou 'Combined' (o comportamento antigo).
 * Vem do servidor, uma vez; se não responder, assume-se 'Combined' — o que sempre existiu — para nunca deixar o utilizador sem ecrã.
 */
let cached = null;

export const getDeploymentMode = () => {
  if (cached) return cached;
  cached = (async () => {
    try {
      if (typeof fetch !== 'function') return 'Combined';
      const res = await fetch('/health/deployment', { headers: { Accept: 'application/json' } });
      if (!res.ok) return 'Combined';
      const data = await res.json();
      return ['Platform', 'Gym', 'Combined'].includes(data?.mode) ? data.mode : 'Combined';
    } catch {
      return 'Combined';
    }
  })();
  return cached;
};

/** Só para testes. */
export const resetDeploymentModeCache = () => { cached = null; };
